<template>
  <div class="flex flex-col">
    <div class="flex border-b border-secondary p-4">
      <div class="w-80">
        <text-input
          v-model="searchTerm"
          :placeholder="$t('frontend_images_search')"
          @keydown.enter="search();"
          variant="dark"
        />
      </div>
    </div>
    <div ref="imageContainer" class="flex flex-grow">
      <div
        class="flex flex-wrap p-4 overflow-auto"
        :style="{ 'height': maxHeight, 'max-height': '65vh'}"
      >
        <div
          v-for="image in searchResults"
          :key="image.id"
          class="w-48 h-48 rounded border m-2 border-secondary-lighter relative"
          @mouseout="hovered = null;"
          @mouseover="hovered = image.id;"
        >
          <div
            class="h-full w-full"
            :style="getImageStyle(image)"
            :class="{ 'opacity-50': isActive(image.id) }"
          ></div>
          <div
            class="absolute inset-0 w-full h-full flex items-center justify-center"
            :class="{ hidden: !isActive(image.id) }"
            @click="uploadImage(image.id);"
          >
            <div
              class="font-bold mr-3 text-secondary-invert text-center"
              v-text="overlayText(image.id)"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <loader v-if="searching" theme="dark"></loader>
    <div ref="moreResults">
      <div v-if="moreSearchResults" class="border-b border-secondary-lighter"></div>
      <div v-if="moreSearchResults" class="flex justify-center">
        <div class="m-4 w-80 flex">
          <gd-button variant="dark" size="expand" @click="loadMoreResults();">{{
            $t('frontend_images_load_more')
          }}</gd-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@groovepages/gd-lib/api';
import GdButton from '../Button';
import Loader from '../Loader';
import TextInput from '../TextInput';

export default {
  components: { Loader, TextInput, GdButton },
  props: ['container'],
  data() {
    return {
      searching: false,
      searchTerm: '',
      searchResults: [],
      moreSearchResults: false,
      resultsPage: 1,
      unsplashUpload: null,
      hovered: null,
      uploading: [],
      maxHeight: null
    };
  },
  created() {
    window.addEventListener('resize', this.setMaxHeight);
  },
  destroyed() {
    window.removeEventListener('resize', this.setMaxHeight);
  },
  methods: {
    setMaxHeight() {
      if (!this.searchResults || !this.$refs.imageContainer) {
        this.maxHeight = null;
        return;
      }
      const height =
        window.screen.height -
        this.$refs.imageContainer.offsetTop -
        this.$refs.moreResults.clientHeight -
        (window.screen.height - this.container.clientHeight);
      this.maxHeight = height + 'px';
    },
    isActive(id) {
      return id === this.hovered || this.uploading.indexOf(id) !== -1;
    },
    overlayText(id) {
      if (this.uploading.indexOf(id) === -1)
        return this.$t('frontend_images_add_to_my_images');
      else return this.$t('frontend_uploading');
    },
    uploadImage(id) {
      this.uploading.push(id);
      api
        .get(
          `${
            window.gdEnv.VUE_APP_API_URL
          }/groovedigital/images/unsplash/save/${id}`
        )
        .then(res => {
          this.$emit('uploaded', res);
          this.uploading = this.uploading.filter(stored => stored !== id);
        });
    },
    getImageStyle(image) {
      return `background-image: url('${
        image.urls.thumb
      }');background-repeat: no-repeat;background-size: cover;background-position: 50% 50%;`;
    },
    search() {
      this.resultsPage = 1;
      this.searchResults = [];
      this.unsplashCall();
    },
    unsplashCall() {
      if (!this.searchTerm) return;
      this.searching = true;
      api
        .get(
          `${
            window.gdEnv.VUE_APP_API_URL
          }/groovedigital/images/unsplash/search/${this.searchTerm}/${
            this.resultsPage
          }`
        )
        .then(res => {
          this.searchResults = this.searchResults.concat(res);
          if (res.length === 30) this.moreSearchResults = true;
          else this.moreSearchResults = false;
          this.searching = false;
          this.$nextTick(() => {
            this.setMaxHeight();
          });
        })
        .catch(() => {
          this.searching = false;
          this.moreSearchResults = false;
          this.$nextTick(() => {
            this.setMaxHeight();
          });
        });
    },
    loadMoreResults() {
      this.resultsPage += 1;
      this.unsplashCall();
    }
  }
};
</script>
